import {
  Box,
  Card,
  Table,
  TableBody,
  TableBodyCell,
  TableBodyRow,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  Text,
  theme,
} from "@aksara-ui/react";
import { InputSearchbox } from "components/Form/InputSearchbox";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { getAllGroupActivies, getAllLogActivities } from "redux/actions";
import styled from "styled-components";
import {
  Pagination,
  PaginationDetail,
  PaginationFilter,
} from "components/Pagination";
import TableBodyRowsSkeleton from "components/TableBodyRowSkeleton";
import moment from "moment";
import FilterKit from "components/FilterKit";

const HeaderWrapper = styled(Box)`
  justify-content: space-between;
  margin-bottom: 30px;
  gap: 20px;
`;

const LogActivityContent: React.FC = () => {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const isTablet = useMediaQuery({ maxWidth: 1024 });

  const { isLoading } = useSelector((state: any) => state.globalReducer);
  const { logActivities, logGroupActivityFilters, logActivityPortalFilters } =
    useSelector((state: any) => state.logActivityReducer);
  const {
    currentPage,
    totalPage,
    limitPage,
    lengthPage,
    filterGroupActivityPage,
    filterPortalPage,
  } = useSelector((state: any) => state.logActivityReducer);

  const [searchValue, setSearchValue] = useState("");
  const [limit, setLimit] = useState(10);

  const handleSearchChange = (event: any) => {
    setSearchValue(event.target.value);
    dispatch(
      getAllLogActivities(
        1,
        event.target.value,
        limitPage,
        filterGroupActivityPage,
        filterPortalPage
      ) as any
    );
  };

  const handleClearSearchChange = () => {
    setSearchValue("");
    dispatch(
      getAllLogActivities(
        currentPage,
        "",
        limitPage,
        filterGroupActivityPage,
        filterPortalPage
      ) as any
    );
  };

  useEffect(() => {
    dispatch(getAllGroupActivies() as any);
    dispatch(getAllLogActivities() as any);
  }, [dispatch]);

  return (
    <Box height={"100%"} paddingY={20} paddingX={isMobile ? 30 : 50}>
      <HeaderWrapper
        display={"flex"}
        flexDirection={"column"}
        style={{ gap: 20 }}
      >
        <Box display={"flex"}>
          <Text scale={[500, 600]} fontWeight={700}>
            Log Activity
          </Text>
        </Box>

        <Box
          display={"flex"}
          flexDirection={isTablet ? "column" : "row"}
          justifyContent={"left"}
          style={{ gap: 5 }}
        >
          <InputSearchbox
            autoComplete="off"
            name="search"
            placeholder="Search..."
            size={32}
            onChange={handleSearchChange}
            onClearButton={handleClearSearchChange}
          />

          <Box
            display={"flex"}
            flexDirection={isMobile ? "column" : "row"}
            justifyContent={"left"}
            style={{ gap: 5 }}
          >
            <FilterKit
              orderByOptions={[
                {
                  key: logGroupActivityFilters,
                  label: "Activity",
                  options: logGroupActivityFilters.map((activity: any) => {
                    return {
                      label: activity.group_activity,
                      value:
                        activity.group_activity !== "All"
                          ? activity.group_activity
                          : "",
                    };
                  }),
                },
              ]}
              onChangeOrder={(e: any) => {
                dispatch(
                  getAllLogActivities(
                    1,
                    "",
                    limitPage,
                    e[logGroupActivityFilters]
                      ? e[logGroupActivityFilters].value
                      : "",
                    filterPortalPage
                  ) as any
                );
              }}
            />

            <FilterKit
              orderByOptions={[
                {
                  key: logActivityPortalFilters,
                  label: "Portal",
                  options: logActivityPortalFilters.map((portal: any) => {
                    return {
                      label: portal,
                      value: portal !== "All" ? portal : "",
                    };
                  }),
                },
              ]}
              onChangeOrder={(e: any) => {
                dispatch(
                  getAllLogActivities(
                    1,
                    "",
                    limitPage,
                    filterGroupActivityPage,
                    e[logActivityPortalFilters]
                      ? e[logActivityPortalFilters].value
                      : ""
                  ) as any
                );
              }}
            />
          </Box>
        </Box>
      </HeaderWrapper>

      <Card maxHeight={"100%"} overflow={"auto"} elevation={2}>
        <Table>
          <TableHead
            position={"sticky"}
            top={0}
            backgroundColor={theme.colors.grey02}
          >
            <TableHeadRow>
              <TableHeadCell>Activity</TableHeadCell>
              <TableHeadCell minWidth={200}>Detail</TableHeadCell>
              <TableHeadCell>User Email</TableHeadCell>
              <TableHeadCell>IP</TableHeadCell>
              <TableHeadCell>Portal</TableHeadCell>
              <TableHeadCell>Date/Time</TableHeadCell>
            </TableHeadRow>
          </TableHead>
          <TableBody>
            {isLoading ? (
              <TableBodyRowsSkeleton rowsNumber={10} columnsNumber={6} />
            ) : !logActivities.length ? (
              <TableBodyRow>
                <TableBodyCell colSpan={6} textAlign={"center"}>
                  No data available in table
                </TableBodyCell>
              </TableBodyRow>
            ) : (
              logActivities.map((log: any) => {
                return (
                  <TableBodyRow key={log.id}>
                    <TableBodyCell>{log.group_activity}</TableBodyCell>
                    <TableBodyCell>{log.detail_activity}</TableBodyCell>
                    <TableBodyCell>{log.user_email}</TableBodyCell>
                    <TableBodyCell>{log.ip}</TableBodyCell>
                    <TableBodyCell>{log.portal}</TableBodyCell>
                    <TableBodyCell>
                      {moment(log.created_at).format("DD MMMM YYYY, HH:mm:ss")}
                    </TableBodyCell>
                  </TableBodyRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </Card>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingY={10}
      >
        {!isMobile ? (
          <PaginationDetail
            page={currentPage}
            limit={limitPage}
            length={lengthPage}
          />
        ) : (
          ""
        )}
        <Pagination
          current={currentPage}
          total={totalPage}
          onSelect={(select: any) =>
            dispatch(
              getAllLogActivities(
                select,
                searchValue,
                limitPage,
                filterGroupActivityPage,
                filterPortalPage
              ) as any
            )
          }
        />
        <PaginationFilter
          selectedItem={limit}
          onChange={(selectedItem) => {
            if (selectedItem) {
              setLimit(selectedItem);
              dispatch(
                getAllLogActivities(
                  1,
                  searchValue,
                  selectedItem,
                  filterGroupActivityPage,
                  filterPortalPage
                ) as any
              );
            }
          }}
          items={[10, 20, 30, 40, 50]}
        />
      </Box>
    </Box>
  );
};

export default LogActivityContent;
